// frontend/src/hooks/useCourses.ts

import { useEffect, useState, useCallback } from 'react';
import { coursesService } from '../services/courses.service';
import { useAuthStore } from '../store/authStore';
import { Course } from '../types/courses.types';

export function useCourses() {
  const userId = useAuthStore((s) => s.session?.user.id);
  const [courses, setCourses] = useState<Course[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!userId) return;
    setIsLoading(true);
    setError(null);
    try {
      const data = await coursesService.listCoursesWithProgress(userId);
      setCourses(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Dersler yüklenemedi.');
    } finally {
      setIsLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { courses, isLoading, error, reload };
}
